import { getAccountIdentifier } from 'v2/pages/settings/integrations/utils/account-identifier'
import type { RExternalOrgApp } from 'v2/types/api/settings'

interface ActionConnectionLabelProps {
  app: RExternalOrgApp
  accountInfo?: string
}

/**
 * Lives in its own module so `integration-action-options` can stay a pure helper
 * file. A module that exports a component AND plain helpers defeats React Fast
 * Refresh for every consumer of those helpers (react-doctor/only-export-components).
 */
export const ActionConnectionLabel = ({ app, accountInfo }: ActionConnectionLabelProps) => {
  const resolvedAccountInfo = accountInfo ?? getAccountIdentifier(app)
  return (
    <div className="flex items-center gap-2">
      <span className="text-s-500">{app.name}</span>
      {resolvedAccountInfo && (
        <span className="text-xs-400 text-tertiary">({resolvedAccountInfo})</span>
      )}
    </div>
  )
}
